import React from 'react';

import { isImage } from 'helpers/utils';

import IconThumbnail from './IconThumbnail';
import ImageThumbnail from './ImageThumbnail';

type Props = {
  fileUpload: Backend.FileUpload;
  disablePreview?: boolean;
  onClick?: () => void;
};

function Thumbnail({ fileUpload, disablePreview = false, onClick = () => {} }: Props) {
  return (
    <div className="flex h-full w-full items-center justify-center" onClick={onClick} role="presentation">
      {isImage(fileUpload.filename) ? (
        <ImageThumbnail
          disablePreview={disablePreview}
          filename={fileUpload.filename}
          url={fileUpload.file}
          thumbnailUrl={`${fileUpload.file}__320x320.png`}
        />
      ) : (
        <a
          href={fileUpload.file}
          download={fileUpload.filename}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'block', width: '100%', height: '100%' }}
        >
          <IconThumbnail filename={fileUpload.filename} url={fileUpload.file} />
        </a>
      )}
    </div>
  );
}

export default Thumbnail;
